import { h, Component } from 'preact';
import {convertToTimestamp} from 'helpers';

export class CartProvider extends Component {

	update = () => {
		localStorage.setItem(`Lippumaatti--Cart`, JSON.stringify(this.state.items));
	}
	parseCart = (items) => {
		return items.reduce((final, item) => {
			const foundItemIndex = final.reduce((found, existing, index) => found === null && item.ticket_id === existing.ticket_id ? index : found, null);
			item.quantity = parseInt(item.quantity);
			if(foundItemIndex !== null) {
				final[foundItemIndex].quantity = final[foundItemIndex].quantity+item.quantity
			} else if(item.quantity){
				final.push(item)
			}
			return final;
		}, [])
	}
	state = {
		items: (localStorage.getItem('Lippumaatti--Cart') ? this.parseCart(JSON.parse(localStorage.getItem('Lippumaatti--Cart'))) : []).filter(item => !item.deadline || convertToTimestamp(item.deadline) > new Date())
	}
	getChildContext() {
		return {
			cart: {
				addItems: (items) => { this.setState({ items: this.parseCart([...this.state.items, ...items]) }, this.update); return items },
				setItems: (items) => { this.setState({items: this.parseCart(items)}, this.update); return items },
				getTotal: (cart) => { return (cart || this.state.items).reduce((total, item) => total + (item.quantity * item.price), 0) },
				clearCart: () => { this.setState({items: []}, this.update); return [] },
				getItems: () => { return this.state.items }
			}
		};
	}
	render({ children }) {
		return children[0];
	}
}
export default CartProvider



// WEBPACK FOOTER //
// ./components/cart/index.js